import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Service } from '@app/shared/models/service';

@Injectable({
  providedIn: 'root'
})
export class DiscoveryService {

  constructor(private http: HttpClient) { }

  getNamespace(): Observable<{
    services: Service[],
    region: string,
    country: string,
    countryCode: string,
  }> {
    return this.http.get<
      {
        services: Service[],
        region: string,
        country: string,
        countryCode: string,
      }
    >('https://' + environment.prefixUrl + 'discovery.fromsmash.co/namespace/public/services');
  }

  getNamespaceByRegion(region: string): Observable<{
    services: Service[],
    region: string,
    country: string,
    countryCode: string,
  }> {
    return this.http.get<{
      services: Service[],
      region: string,
      country: string,
      countryCode: string,
    }>('https://' + environment.prefixUrl + 'discovery.' + region + '.fromsmash.co/namespace/public/services');
  }

}
